import React from 'react'

//WsWebServicePlatform/InteractionLog/Append
//props:
//authtoken
//groupguid
/* "InteractionElement": {
                            "ClassKeyName": "REPORT COMPONENT",
                            "FamilyKeyName": "CLICKED",
                            "TypeKeyName": "BUTTON",
                            "ComponentGuid": "8982C56C-2965-4EF2-BFF2-82CE14827FA5",
                            "Record": "1"
                          }
                          */
export function InteractionHandler(props){
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify(
            {"ParamData": {
                "OrganizationGuid": props.groupguid,
                "AuthToken": props.authtoken,
                "InteractionClassKeyName": props.InteractionElement.ClassKeyName,
                "InteractionFamilyKeyName": props.InteractionElement.FamilyKeyName,
                "InteractionTypeKeyName": props.InteractionElement.TypeKeyName,
                "ComponentGuid": props.InteractionElement.ComponentGuid
            }}
        )
    }

    fetch('../../WsWebServicePlatform/InteractionLog/Append', requestOptions)
}